import { Dispatch, FC, SetStateAction } from 'react';
import { RadioSelector } from 'src/components/_commons';

export type typeOption = 'byType' | 'byDate' | 'byCalendar';

type propsType = {
    radioValue: typeOption;
    setRadioValue: Dispatch<SetStateAction<typeOption>>;
};

export const PublicMinistryRadio: FC<propsType> = ({ radioValue, setRadioValue }) => {
    return (
        <RadioSelector
            options={[
                { label: radioValue === 'byType' ? 'Ver por Tipo' : 'Viendo por Tipo', type: 'byType' },
                { label: radioValue === 'byDate' ? 'Ver por Fecha' : 'Viendo por Fecha', type: 'byDate' },
                { label: radioValue === 'byCalendar' ? 'Ver Calendario' : 'Viendo Calendario', type: 'byCalendar' }
            ]}
            radioValue={radioValue}
            setRadioValue={setRadioValue}
        />
    )
}
